
import { Options, Vue }    from 'vue-class-component';
import CheckboxRound from '../components/shared/checkbox-round.vue'
import {reactive, ref} from 'vue';

@Options({
  data(){
    const contactStore = this.$store.state.contact
    return{
      contact: {
        firstName: (contactStore || {}).firstName || null,
        lastName: (contactStore || {}).lastName || null,
        email: (contactStore || {}).email || null,
        phone: (contactStore || {}).phone || null,
        address: (contactStore || {}).address || null,
        city: (contactStore || {}).city || null,
        postalCode: (contactStore || {}).postalCode || null,
        note: (contactStore || {}).note || null,
        deliveryType: (contactStore || {}).deliveryType || 'pickup',
        deliveryAddress: (contactStore || {}).deliveryAddress || null,
        deliveryCity: (contactStore || {}).deliveryCity || null,
        deliveryPostalCode: (contactStore || {}).deliveryPostalCode || null,
        sameDeliveryAddress: (contactStore || {}).sameDeliveryAddress === false ? false : true
      },
      errors: []
    }
  },
  setup(){
    const formRef = ref();

    const formState = reactive({
      quantity: undefined
    });

    return {
      formRef,
      formState
    }
  },
  components: {
    CheckboxRound
  },
  watch: {
    '$store.state.counter'(){
      this.$store.commit('setContact',this.contact)
      this.$refs.formRef
          .validate()
          .then(() => {
            this.$router.push(this.$router.currentRoute.value.meta.next)
          })
          .catch(error => {
            console.log('error', error);
          });
    }
  },
  methods: {
    async validateArea(r, v) {
      if (v) {
        return Promise.resolve();
      } else {
        return Promise.reject('Polje je obvezno!');
      }
    },
    async validateEmail(r, v) {
      const regex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')
      if (v && regex.test(v)) {
        return Promise.resolve();
      } else {
        return Promise.reject('Polje je obvezno!');
      }
    }
  }
})
export default class YourInfo extends Vue {
}
